import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Box, FilterButton, IconButton, Popover, TextInput } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { getNumberDisplayValue } from './utils';
import { useFilter } from '../useFilter';
export function NumberRangeOperator(props) {
    var _a, _b, _c, _d, _e, _f;
    const { name } = props;
    const filter = useFilter(name);
    const currentFromValue = ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.gte) || ((_b = filter.value) === null || _b === void 0 ? void 0 : _b.gt) || undefined;
    const currentToValue = ((_c = filter.value) === null || _c === void 0 ? void 0 : _c.lte) || ((_d = filter.value) === null || _d === void 0 ? void 0 : _d.lt) || undefined;
    const initialData = { gte: currentFromValue, lte: currentToValue };
    const [open, setOpen] = useState(false);
    const [newValue, setNewValue] = useState(initialData);
    const hasNewValue = JSON.stringify(initialData) !== JSON.stringify(newValue);
    const displayValue = getNumberDisplayValue(newValue.gte, newValue.lte);
    const handleOnChange = (key) => (ev) => {
        const { value } = ev.target;
        const numberValue = parseInt(value, 10);
        setNewValue(Object.assign(Object.assign({}, newValue), { [key]: numberValue }));
    };
    const handleApplyNewValue = () => {
        filter.applyValue(Object.assign(Object.assign({}, filter.value), newValue));
        setOpen(false);
    };
    return (<Popover shadow="300" open={open} padding={0} onClose={handleApplyNewValue} target={<FilterButton type="button" appearance={filter.isTouched ? 'draft' : 'default'} onClick={() => setOpen(!open)}>
          {displayValue}
        </FilterButton>}>
      <Box gap="md" px="md" pb="md" alignItems="flex-end">
        <TextInput label={t({ message: 'Greater than or equal to', comment: 'Insights: Number range filter: From' })} placeholder={t({ message: 'From', comment: 'Insights: Number range filter: From' })} type="number" value={(_e = newValue.gte) !== null && _e !== void 0 ? _e : undefined} onChange={handleOnChange('gte')}/>
        <TextInput label={t({ message: 'Less than or equal to', comment: 'Insights: Number range filter: To' })} placeholder={t({ message: 'To', comment: 'Insights: Number range filter: To' })} type="number" value={(_f = newValue.lte) !== null && _f !== void 0 ? _f : undefined} onChange={handleOnChange('lte')}/>
        <IconButton type="button" appearance="secondary" disabled={!hasNewValue} onClick={handleApplyNewValue} aria-label={t({ message: 'Click to apply filter', comment: 'Search filter: Number filter apply filter' })}>
          <Falcon icon="check"/>
        </IconButton>
      </Box>
    </Popover>);
}
